import { Divider } from 'antd';

const Ryplazim = () => {
  return (
    <>
      <div className="bg-[#f3f3f3] p-4 md:p-8 pt-4 rounded-md">
        <Divider />
        <p className="m-2 font-bold">INDICATIONS AND USAGE</p>

        <p className="m-2">
          RYPLAZIM® (plasminogen, human-tvmh) is a plasma-derived human plasminogen indicated for
          the treatment of patients with plasminogen deficiency type 1 (hypoplasminogenemia).{' '}
        </p>

        <p className="m-2 font-bold">IMPORTANT SAFETY INFORMATION</p>

        <div className="m-2">
          <b>CONTRAINDICATIONS:</b>
          <p className="m-2 ml-10">
            RYPLAZIM is contraindicated in patients with known hypersensitivity to plasminogen or
            other components of RYPLAZIM.
          </p>
        </div>

        <div className="m-2">
          <b>WARNINGS AND PRECAUTIONS:</b>
          <p className="m-2 ml-10">
            Bleeding: RYPLAZIM administration may lead to bleeding at active mucosal disease-related
            lesion sites or worsen active bleeding not related to disease lesions. Discontinue
            RYPLAZIM if serious bleeding occurs. Monitor patients during and for 4 hours after
            infusion when administering RYPLAZIM to patients with bleeding diatheses and patients
            taking anticoagulants, antiplatelet drugs, or other agents which may interfere with
            normal coagulation.
          </p>
          <p className="m-2 ml-10">
            Tissue Sloughing: Respiratory distress due to tissue sloughing may occur in patients
            with mucosal lesions in the tracheobronchial tree following RYPLAZIM administration.
            Please monitor appropriately.
          </p>
          <p className="m-2 ml-10">
            Transmission of Infectious Agents: RYPLAZIM is made from human plasma and therefore
            carries a risk of transmitting infectious agents, e.g., viruses, the variant
            Creutzfeldt-Jakob disease (vCJD) agent, and theoretically, the Creutzfeldt-Jakob Disease
            (CJD) agent.
          </p>
          <p className="m-2 ml-10">
            Hypersensitivity Reactions: Hypersensitivity reactions, including anaphylaxis, may occur
            with RYPLAZIM. If symptoms occur, discontinue RYPLAZIM and administer appropriate
            treatment.
          </p>
          <p className="m-2 ml-10">
            Neutralizing Antibodies: Neutralizing antibodies (inhibitors) may develop, although they
            were not observed in clinical trials. If clinical efficacy is not maintained (e.g.,
            development of new or recurrent lesions), determine plasminogen activity trough levels
            in plasma.
          </p>
          <p className="m-2 ml-10">
            Laboratory Abnormalities: Patients receiving RYPLAZIM may have elevated blood levels of
            D-dimer. D-dimer levels will lack interpretability in patients being screened for venous
            thromboembolism (VTE).
          </p>
        </div>

        <div className="m-2">
          <b>ADVERSE REACTIONS:</b>
          <p className="m-2 ml-10">
            The most frequent (incidence ≥ 10%) adverse reactions in clinical trials were abdominal
            pain, bloating, nausea, fatigue, extremity pain, hemorrhage, constipation, dry mouth,
            headache, dizziness, arthralgia, and back pain.
          </p>
        </div>

        <div>
          <p className="m-2">
            <b>
              Please see&nbsp;
              <a
                target="_blank"
                href="/Ryplazim-Prescribing-Information.pdf"
                className="text-blue-500 hover:underline"
              >
                RYPLAZIM full Prescribing Information
              </a>
              &nbsp;for complete prescribing details.
            </b>
          </p>
          <p className="m-2">
            <b>
              You are encouraged to report negative side effects of prescription drugs to the FDA.
              Visit&nbsp;
              <a
                target="_blank"
                href="http://www.fda.gov/medwatch"
                className="text-blue-500 hover:underline"
              >
                www.fda.gov/medwatch
              </a>
              &nbsp;or call 1-800-FDA-1088.
            </b>
          </p>
        </div>
      </div>
    </>
  );
};

export default Ryplazim;
